import * as React from 'react';
import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import { SearchDriveItemState } from '../reducer';
import { DriveItemListSearchFieldDisplayType } from './constants';
import { DriveItemListSearchFieldContainerVariants, ButtonIcon, DriveItemListSearchFieldInput } from './styles';
import RoutesUtils from '../../../../utils/routes';
import { DriveItemListOrigin } from '../../../DriveItemListPage/constants';
const I18n = require('react-redux-i18n').I18n;

export interface DriveItemListSearchFieldProps {
	searchText?: string;
	search: SearchDriveItemState;
	displayType: DriveItemListSearchFieldDisplayType;
}

export interface DriveItemListSearchFieldState {
	searchText: string;
}

class DriveItemListSearchField extends React.Component<DriveItemListSearchFieldProps, DriveItemListSearchFieldState> {

 	constructor(props: DriveItemListSearchFieldProps) {
		super(props);
		this.handleClickClear = this.handleClickClear.bind(this);
		this.handleSendForm = this.handleSendForm.bind(this);
		this.handleSearchTextChange = this.handleSearchTextChange.bind(this);
		this.state = { searchText: this.props.searchText || '' };
	}

	componentWillReceiveProps(nextProps: DriveItemListSearchFieldProps) {
		if (this.props.searchText !== nextProps.searchText) {
			this.setState({ searchText: nextProps.searchText || '' });
		}
	}

	render() {
		const { search, displayType } = this.props;
		const { searchText  } = this.state;
		const Container = DriveItemListSearchFieldContainerVariants[displayType];

		return (
			<Container isShown={search.isShown} onSubmit={this.handleSendForm}>
				<ButtonIcon type="submit" isLeft={true}>
					{Utils.getSvgIcon('iconset_search')}
				</ButtonIcon>
				<DriveItemListSearchFieldInput
					value={searchText}
					onChange={this.handleSearchTextChange}
					placeholder={I18n.t('messages.placeholder_search_drive_item')}
					isEmpty={!searchText}
				/>
				{searchText &&
					<ButtonIcon onClick={this.handleClickClear} isLeft={false}>
						{Utils.getSvgIcon('iconset_close-1')}
					</ButtonIcon>
				}
			</Container>
		);
	}

	private handleSendForm(e: React.FormEvent<HTMLFormElement>): void {
		e.preventDefault();
		window.location.hash = `#${RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Search, encodeURIComponent(this.state.searchText))}`;
	}

	private handleClickClear(e: React.MouseEvent<HTMLButtonElement>): void {
		e.preventDefault();
		this.setState({ searchText: '' });
		window.location.hash = `#${RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Search, null)}`;
	}

	private handleSearchTextChange(e: React.FormEvent<HTMLInputElement>): void {
		this.setState({ searchText: e.currentTarget.value });
	}
}

const mapStateToProps = (state: StoreState) => {
	const { search } = state;
	return { search };
};

export default connect(mapStateToProps)(DriveItemListSearchField);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Search/Field/index.tsx